import React, { useEffect } from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import ContentWrapper from "styles/contentWrapper"

const spot1 = 'https://hrflow-ai.imgix.net/backgrounds/spot.svg'
const spot2 = 'https://hrflow-ai.imgix.net/backgrounds/mini-spot.svg'
const spot3 = 'https://hrflow-ai.imgix.net/backgrounds/circle-spot.svg'


const StyledSection = styled.section`
  width: 100%;
  height: auto;
  padding: 3rem 0;
  background-image: url(${spot1}), url(${spot2}), url(${spot3});
  background-size: 16rem 22.5rem, 1.5rem 2rem, 2.55rem 2.55rem;
  background-position: 5% 45%, 5% 27%, 98% 98%;
  background-repeat: no-repeat;
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 2.5rem;
    padding-left: 2.5rem;
    .section-title {
      color: ${({ theme }) => theme.colors.primary};
      text-align: center;
      margin-top: 0;
      margin-bottom: 3rem;
      padding: 0 1rem;
      @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
        padding-right: 0;
        padding-left: 0;
      }
      span {
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
  }
`

const StyledVideo = styled.div`
  .iframe-wrapper-small, .iframe-wrapper-large {
    margin-bottom: 2rem;
  }
  .iframe-wrapper-small {
    display: none;
  }
  .iframe-wrapper-large {
    display: block;
    width: 100%;
    max-width: 60rem;
    margin: auto;
    iframe {
      border-radius: 6px;
      box-shadow: 0 1rem 2.5rem rgba(132, 156, 156, 0.15);
      background-color: white;  
    }
  }
  @media (max-width: 1200px) {
    flex: 1 1 100%;
  }
  @media (max-width: 600px) {
    .iframe-wrapper-small {
      display: block;
    }
    .iframe-wrapper-large {
      display: none;
    }
  }
`

const Video = ({ content }) => {
  const { frontmatter } = content[0].node

  return (
    <StyledSection id="Video">
      <StyledContentWrapper>
        <h2 className="section-title">{frontmatter.title}<br /><span>{frontmatter.titlePrefix}</span></h2>
        <StyledVideo>
          <div className="iframe-wrapper-large">
            <iframe width="100%" height="450" src="//www.youtube.com/embed/FbdbN4Edu44" frameBorder="0" allowFullScreen></iframe>
          </div>
          <div className="iframe-wrapper-small">
            <iframe width="100%" height="157.5" src="//www.youtube.com/embed/FbdbN4Edu44" frameBorder="0" allowFullScreen></iframe>
          </div>
        </StyledVideo>
      </StyledContentWrapper>
    </StyledSection>
  )
}

Video.propTypes = {
  content: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.shape({
        frontmatter: PropTypes.object.isRequired,
      }).isRequired,
    }).isRequired
  ).isRequired,
}

export default Video

